var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-foundation'),_c('app-typography'),_c('app-margins'),_c('app-padding'),_c('app-buttons'),_c('app-layout'),_c('app-uploader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }